<div class="flex h-screen overflow-hidden bg-gray-50">

  
  <app-sidebar #sidebar></app-sidebar>
   <header class="h-16 flex items-center px-4 border-b border-[var(--color-border)] lg:hidden">
      <button
        (click)="sidebar.openMobile()"
        class="w-10 h-10 rounded-xl flex items-center justify-center
               text-[var(--color-muted-foreground)]
               hover:bg-[var(--color-primary-light)]
               transition-all duration-200 cursor-pointer"
      >
        <i class="bi bi-list text-xl"></i>
      </button>
    </header>

  <!-- Main area -->
  <div class="flex-1 flex flex-col min-w-0 overflow-hidden">

    <!-- Top Header -->
    <header class="h-16 bg-white border-b border-gray-100 flex items-center px-6 flex-shrink-0 gap-4 shadow-sm">
      <div class="flex-1 min-w-0">
        <h2 class="text-sm font-semibold text-primary truncate">{{ getUser()?.username || 'Organisation' }}</h2>
      </div>

      <div class="flex items-center gap-3">
        <!-- Notifications -->
        <button class="w-9 h-9 rounded-lg border border-gray-200 flex items-center justify-center text-secondary hover:border-accent hover:text-accent transition-colors relative">
          <i class="bi bi-bell text-base"></i>
          <span class="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-accent"></span>
        </button>

        <!-- Profile chip -->
        <div class="flex items-center gap-2 px-3 py-1.5 rounded-lg border border-gray-200 bg-gray-50">
          <div class="w-6 h-6 rounded-full bg-primary flex items-center justify-center">
            <i class="bi bi-person-fill text-white text-xs"></i>
          </div>
          <span class="text-xs font-medium text-primary">{{ getUser()?.firstName }} </span>
        </div>
      </div>
    </header>

    <!-- Page content -->
    <main class="flex-1 overflow-y-auto p-6">
      <router-outlet></router-outlet>
    </main>

  </div>
</div>